import 'core-js'
import React from 'react';
import ReactDOM from 'react-dom';
import MapSearchAppRouter from './routers/MapSearchAppRouter';
import 'whatwg-fetch';

import { MarkersContextProvider } from './contexts/markers-context';
import { GeolocationContextProvider } from './contexts/geolocation-context';
import { LocalizationContextProvider } from './contexts/localization-context';
import { MapContextProvider } from './contexts/map-context';
if (!window._babelPolyfill) {
    require('babel-polyfill');
}

ReactDOM.render(
    <MarkersContextProvider>
        <GeolocationContextProvider>
            <LocalizationContextProvider>
                <MapContextProvider>
                    <MapSearchAppRouter />
                </MapContextProvider>
            </LocalizationContextProvider>
        </GeolocationContextProvider>
    </MarkersContextProvider>
    ,
    document.getElementById('MapSearchApp')
);
